/* eslint-disable prettier/prettier */
import {
  makeStyles,
  Theme,
  createStyles,
  Paper,
  List,
  ListItem,
  Grid,
  ListItemText,
  Divider,
} from '@material-ui/core';
import { IconButton } from 'app/components/BasicButtons/IconButton';
import { Icon } from 'app/components/BasicIcons/FontAwesome';
import { ScreensId } from 'enums/ConfigurableTypes';
import { translations } from 'locales/translations';
import { useTranslation } from 'react-i18next';
import { toRootedURL } from 'utils/url-utils';

export const HtmlDefaultTemplate: string =
  '<p ></p><p >Company name, IL 60637</p><p >Invoice ID: {@InvoiceLinkId}</p><p >Dates: From {@InvoiceFromDate} To {@InvoiceToDate}</p><p > </p><table style="height: 70px; width: 99.3288%; border-collapse: collapse; border: solid 1px; font-size: 13px; margin: center;" ><tbody ><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Invoice Date</td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Processed By</td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >User Group</td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Core</td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Total Cost</td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF;" ><p >{@InvoiceDate}</p></td><td style="border: solid 1px #CCCCCF;" ><p >{@InvoiceProcessedUser}</p></td><td style="border: solid 1px #CCCCCF;" ><p >{@InvoiceUserGroup}</p></td><td style="border: solid 1px #CCCCCF;" ><p >{@InvoiceCore}</p></td><td style="border: solid 1px #CCCCCF;" >{@InvoiceTotalCost}</td></tr></tbody></table><p > </p><table style="height: 70px; width: 99.3288%; border-collapse: collapse; border: solid 1px; font-size: 13px; margin: center;" ><tbody ><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" > </td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Customer </td><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Misc</td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Name</td><td style="border: solid 1px #CCCCCF;" >{@InvoiceProcessedUser}</td><td style="border: solid 1px #CCCCCF;" > </td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Billing Adress</td><td style="border: solid 1px #CCCCCF;" >{@BillingAddress1}</td><td style="border: solid 1px #CCCCCF;" > </td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >City</td><td style="border: solid 1px #CCCCCF;" >{@BillingAddress2}</td><td style="border: solid 1px #CCCCCF;" > </td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >State</td><td style="border: solid 1px #CCCCCF;" >{@BillingAddress3}</td><td style="border: solid 1px #CCCCCF;" > </td></tr><tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;" ><td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;" >Country</td><td style="border: solid 1px #CCCCCF;" >{@BillingAddress4}</td><td style="border: solid 1px #CCCCCF;" > </td></tr></tbody></table><p > </p><p >{@InvoiceSummaryTable}</p><p >Remarks: {@InvoiceRemarks}</p>';

/* export const HtmlDefaultTemplate: string =
  '<p>' +
  'Company name, IL 60637' +
  '</p>' +
  '<p>Invoice ID: {@InvoiceLinkId}</p>' +
  '<p>Dates: From {@InvoiceFromDate} To {@InvoiceToDate}</p>' +
  '<p> </p>' +
  '<table style="height: 70px; width: 99.3288%; border-collapse: collapse; border: solid 1px; font-size: 13px; margin: center;">' +
  '<tbody>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px #CCCCCF; background-color: #D6EEEE;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Invoice Date</td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Processed By</td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">User Group</td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Core</td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Total Cost</td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px; background-color: #D6EEEE;">' +
  '<td style="border: solid 1px #CCCCCF;">' +
  '<p>{@InvoiceDate}</p>' +
  '</td>' +
  '<td style="border: solid 1px #CCCCCF;">' +
  '<p>{@InvoiceProcessedUser}</p>' +
  '</td>' +
  '<td style="border: solid 1px #CCCCCF;">' +
  '<p>{@InvoiceUserGroup}</p>' +
  '</td>' +
  '<td style="border: solid 1px #CCCCCF;">' +
  '<p>{@InvoiceCore}</p>' +
  '</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@InvoiceTotalCost}</td>' +
  '</tr>' +
  '</tbody>' +
  '</table>' +
  '<p> </p>' +
  '<table style="height: 70px; width: 99.3288%; border-collapse: collapse; border: solid 1px; font-size: 13px; margin: center;">' +
  '<tbody>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;"> </td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Customer </td>' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Misc</td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Name</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@InvoiceProcessedUser}</td>' +
  '<td style="border: solid 1px #CCCCCF;"> </td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Billing Adress</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@BillingAddress1}</td>' +
  '<td style="border: solid 1px #CCCCCF;"> </td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">City</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@BillingAddress2}</td>' +
  '<td style="border: solid 1px #CCCCCF;"> </td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">State</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@BillingAddress3}</td>' +
  '<td style="border: solid 1px #CCCCCF;"> </td>' +
  '</tr>' +
  '<tr style="width: 18px; height: 15px; vertical-align: bottom; text-align: center; border: solid 1px;">' +
  '<td style="border: solid 1px #CCCCCF; background-color: #D6EEEE;">Country</td>' +
  '<td style="border: solid 1px #CCCCCF;">{@BillingAddress4}</td>' +
  '<td style="border: solid 1px #CCCCCF;"> </td>' +
  '</tr>' +
  '</tbody>' +
  '</table>' +
  '<p> </p>' +
  '<p>{@InvoiceSummaryTable}</p>' +
  '<p>{@InvoiceSummury_BudgetUserService}</p>' +
  '<p>Remarks: {@InvoiceRemarks}</p>' +
  '<p>More details can be obtained by clicking on the Invoice ID.  The statement total will be charged to your budget accounts as detailed above 5 business days after the statement date. Please contact your facility management with any billing questions.</p>';
 */
export function PopUpListItems(): JSX.Element {
  //SETTINGS
  const { t } = useTranslation();

  //CSS
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      invoiceTemplateRightSection: {
        width: '100%',
        //maxWidth: 570,
        backgroundColor: theme.palette.background.default,
        position: 'relative',
        overflow: 'auto',
        maxHeight: '63vh',
        overflowY: 'auto',
        '&::-webkit-scrollbar': {
          width: '6px',
        },
        '&::-webkit-scrollbar-thumb': {
          boxShadow: `inset 0 0 2px ${theme.palette.common.grayBorders}`,
          borderRadius: '6px',
          backgroundColor: theme.palette.common.grayBorders,
        },
      },
      paper: {
        padding: theme.spacing(2),
        backgroundColor: theme.palette.background.default,
        border: '1px solid #E3E3E3',
      },
    }),
  );
  const classes = useStyles();

  //RENDER
  return (
    <Paper className={classes.paper}>
      <List className={classes.invoiceTemplateRightSection}>
        <ListItem>
          <Grid container>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BillingAddress1}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BillingAddress_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BillingAddress2}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BillingAddress_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BillingAddress3}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BillingAddress_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BillingAddress4}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BillingAddress_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetActivityCode}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetActivityCode_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetCostCenter}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetCostCenter_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetExtraTextField1}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetExtraTextField1_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetExtraTextField2_info}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetExtraTextField2_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetExtraTextField3}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetExtraTextField3_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetExtraTextField4}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetExtraTextField4_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetExtraTextField5}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetExtraTextField5_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetProjectCode}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetProjectCode_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@BudgetProjectName}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetProjectName_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@CoreCostCenter}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.CoreCostCenter_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@CreditCode}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.CreditCode_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceBalance}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceBalance_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceCore}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceCore_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceCurrency}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceCurrency_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceCustomerEHF}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceCustomerEHF_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceCustomerRef}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceCustomerRef_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceDate}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceDate_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceDepartment}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceDepartment_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceFromDate}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceFromDate_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceId}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceId_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceInstitute}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceInstitute_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceInstituteType}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceInstituteType_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceLinkId}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceIdLink_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProcessedUser}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProcessedUser_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProcessedUserEmail}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProcessedUserEmail_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProcessedUserGroup}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProcessedUserGroup_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProcessedUserMobile}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProcessedUserMobile_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProcessedUserPhone}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProcessedUserPhone_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceProject}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceProjectNumber_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceRemarks}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceRemarks_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummary_BudgetUserService_GroupedByBudget}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=5`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummaryTable_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummaryServicesTable}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=3`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummarServicesTable_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummaryTable}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=2`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummaryTable_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummury_BudgetUserService_NoGrouped}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=4`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummaryTable_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummury_BudgetUserService}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=1`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummury_BudgetUserService_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={10} md={10}>
              <ListItemText primary="{@InvoiceSummaryByInvoiceRowsNonGrouped}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ConfigureColumns)}
                variant="ghost"
                shape="square"
                size="small"
                target="_blank"
                href={toRootedURL(
                  `/ConfigurableColumn.aspx?ID=${ScreensId.InvoiceLetters}&type=6`,
                )}
              >
                <Icon icon="cog" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceSummaryByInvoiceRowsNonGrouped)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceToDate}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceToDate_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceTotalCost}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceTotalCost_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceUserGroup}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceAdGroup_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceUserGroupEmail}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceUserGroupEmail_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoiceVAT}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceVAT_template_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@InvoicingRemarks}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.BudgetInvoicingRemarks_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@LastRequestID}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.LastRequestID_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@LetterDate}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.LetterDate_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@ProjectActivity}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ProjectActivity_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@ProjectNumber}" />
              <Divider />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.ProjectNumber_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
            <Grid item xs={11} md={11}>
              <ListItemText primary="{@UserGroupName}" />
            </Grid>
            <Grid item xs={1} md={1}>
              <IconButton
                title={t(translations.InvoiceUserGroup_info)}
                variant="ghost"
                shape="square"
                size="small"
              >
                <Icon icon="info-circle" color="primary" />
              </IconButton>
            </Grid>
          </Grid>
        </ListItem>
      </List>
    </Paper>
  );
}
